import { gql } from '@apollo/client';

export const CREATE_PROJECT = gql`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      title
      description
      createdAt
      members {
        id
        userId
        role
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      title
      description
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: String!) {
    deleteProject(id: $id) {
      id
    }
  }
`;

export const INVITE_PROJECT_MEMBERS = gql`
  mutation InviteProjectMembers($input: InviteProjectMembersInput!) {
    inviteProjectMembers(input: $input) {
      id
      userId
      role
    }
  }
`;

export const UPDATE_PROJECT_MEMBER = gql`
  mutation UpdateProjectMember($input: UpdateProjectMemberInput!) {
    updateProjectMember(input: $input) {
      id
      userId
      role
    }
  }
`;

export const LEAVE_PROJECT = gql`
  mutation LeaveProject($id: String!) {
    leaveProject(id: $id) {
      id
    }
  }
`;

export const REMOVE_PROJECT_MEMBER = gql`
  mutation RemoveProjectMember($input: RemoveProjectMemberInput!) {
    removeProjectMember(input: $input) {
      id
    }
  }
`;
